<app-booking-packs-home *ngIf="!initialize"></app-booking-packs-home>

